import * as React from "react";
import type { SVGProps } from "react";
const SvgMenu04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M13.8 19.2H2.4M21.6 12H2.4m19.2-7.2H2.4"
    />
  </svg>
);
export default SvgMenu04;
